export default __webpack_public_path__ + "static/media/logo-dark.cff2f077.svg";